/* eslint-disable @typescript-eslint/no-confusing-void-expression */
import React, {useState, useEffect} from 'react';
import {Card, Col, Container, Dropdown, Row, Form} from 'react-bootstrap';
import TableContainer from 'Common/TableContainer';
import ApiUtils from 'api/ApiUtils';
import {toast} from 'react-toastify';
import ModalContainer from 'Common/ModalContainer';
import {DOCUMENT_TITLE} from 'Common/constants/layout';
import Swal from 'sweetalert2';
import {variables} from 'utils/constant';
import {useDispatch, useSelector} from 'react-redux';
import {setProductIds} from 'slices/statusChange/reducer';
import {changeStatus} from 'slices/thunk';
import AfterPartyForm from './AfterPartyForm';
import moment from 'moment';

import Select, {type SingleValue} from 'react-select';
import customStyles from 'Common/customStyles';
interface CategoryItemType {
  data: {
    data: [];
    total: number;
  };
  display_header_count: number;
  display_home_count: number;

  message: string;
}

interface Club {
  id: number;
  name: string;
}

const AfterParties = (): JSX.Element => {
  document.title = DOCUMENT_TITLE.AFTER_PARTY;
  const [modalFlag, setModalFlag] = useState<boolean>(false);
  const [editCategory, setEditCategory] = useState<any>({});
  const [isEditCatergory, setIsEditCategory] = useState(false);
  const [iseAddCategory, setIsAddCategory] = useState(false);
  const [sortColumn, setSortColumn] = useState('id');
  console.log('🚀 ~ AfterParties ~ setSortColumn:', setSortColumn);

  const [search, setSearch] = useState<string>('');

  const [sortDirection, setSortDirection] = useState('desc');
  console.log('🚀 ~ AfterParties ~ setSortDirection:', setSortDirection);
  const [categoryList, setCategoryList] = useState<CategoryItemType>();
  const defaultPage = 1;
  const [pageSize, setPageSize] = useState(50);
  const [pageValue, setPageValue] = useState(defaultPage);
  const [totalRecords, setTotalRecords] = useState(defaultPage);

  const currentData = Math.ceil(totalRecords / pageSize);
  const [allChecked, setAllChecked] = useState(false);
  // const [selectedCheckboxes, setSelectedCheckboxes] = useState<string[]>([]);
  const [selectedProductIds, setSelectedProductIds] = useState<number[]>([]);
  const [isCheckboxChanged, setIsCheckboxChanged] = useState(false);
  const dispatch = useDispatch<any>();
  const [isStatusChange, setisStatusChange] = useState(false);

  const [Checked, seChecked] = useState(false);
  const [resetSearchFlag, setResetSearchFlag] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [clubList, setClubList] = useState<Club[]>([]);
  const [filter, setFilter] = useState<any>();

  const handleSelectVenueChange = (
    selectedOptions: SingleValue<number>,
  ): void => {
    setFilter(selectedOptions); // Convert read-only array to mutable array
  };

  const {Layout}: any = useSelector(state => state);
  const [isDark, setIsDark] = useState(false);
  useEffect(() => {
    if (Layout.layoutModeType === 'dark') {
      setIsDark(true);
    } else if (Layout.layoutModeType === 'light') {
      setIsDark(false);
    } else {
      setIsDark(false);
    }
  }, [Layout.layoutModeType]);
  const SelectionOptions = [
    {value: 3, label: 'All'}, // Custom option
    {value: 1, label: 'Puravida party'},
    {value: 2, label: 'Club party'},
  ];
  useEffect(() => {
    ApiUtils.getAfterPartyList(
      `?page=${pageValue}&page_size=${pageSize}&sort_column=${sortColumn}&sort_direction=${sortDirection}&search=${search}&type=upcoming${
        filter?.value === 3 ? '' : `&patry_type=${filter?.value}`
      }`,
    )
      .then(async (data: any): Promise<void> => {
        setCategoryList(data as CategoryItemType);
        setTotalRecords(data?.total);
      })
      .catch((error: any) => {
        toast.error(error.message);
      });

    setisStatusChange(false);
    setAllChecked(false);
  }, [
    pageValue,
    isEditCatergory,
    iseAddCategory,
    pageSize,
    search,
    isStatusChange,
    filter,
  ]);

  // Add a new function to handle normal search
  const handleSearch = (value: string): void => {
    setSearch(value);
    setPageValue(defaultPage);
  };
  const handleDeleteCategory = async (id: any): Promise<void> => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      html: `You won't be able to revert this!<br><br>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (result.isConfirmed) {
      ApiUtils.deleteAfterParty(id)

        // eslint-disable-next-line unused-imports/no-unused-vars
        .then(async data => {
          await Swal.fire({
            title: 'Deleted',
            text: (data as any).message,
            icon: 'success',
          });
          ApiUtils.getAfterPartyList(
            `?page=${pageValue}&page_size=${pageSize}&type=upcoming${
              filter?.value === 3 ? '' : `&patry_type=${filter?.value}`
            }`,
          )
            .then((data: any) => {
              if (data?.current_page > data?.last_page) {
                setPageValue(data?.last_page);
              }
              setCategoryList(data as CategoryItemType);
              setTotalRecords(data?.total);
            })
            .catch((error: any) => {
              toast.error(error.message);
            });
        })
        .catch((error: any) => {
          void Swal.fire({
            title: 'Error!',
            text: error?.response?.data?.message,
            icon: 'error',
          });
        });
      setResetSearchFlag(true);
    }
  };

  const handleNextPagination = (pageSize: any): void => {
    if (currentData > 0 && currentData > pageSize) {
      setPageValue(pageSize + 1);
    }
  };
  const handlePrevPagination = (pageSize: any): void => {
    if (pageSize > 1 && currentData >= pageSize) {
      setPageValue(pageSize - 1);
    }
  };

  // const handleSortByColumn = (column: string): void => {
  //   let newSortDirection = 'asc';

  //   if (column === sortColumn) {
  //     newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
  //   } else {
  //     newSortDirection = 'desc';
  //   }
  //   ApiUtils.getAfterPartyList(
  //     `?page=${pageValue}&page_size=${pageSize}&sort_column=${column}&sort_direction=${newSortDirection}`,
  //   )
  //     .then(async (data: any): Promise<void> => {
  //       setCategoryList(data as CategoryItemType);
  //       setSortDirection(newSortDirection);
  //       setSortColumn(column);

  //       setTotalRecords((data as CategoryItemType)?.data?.total);
  //     })
  //     .catch((error: any) => {
  //       toast.error(error.message);
  //     });
  // };
  const toggleCategoryStatus = async (
    id: number,
    statusId: number,
  ): Promise<void> => {
    // Function to toggle category status

    try {
      // Implement logic to toggle category status
      await ApiUtils.updateAfterParty({id, status: statusId});

      ApiUtils.getAfterPartyList(
        `?page=${pageValue}&page_size=${pageSize}&sort_column=${sortColumn}&sort_direction=${sortDirection}&search=${search}&type=upcoming${
          filter?.value === 3 ? '' : `&patry_type=${filter?.value}`
        }`,
      )
        .then(async (data: any): Promise<void> => {
          toast.success('Status updated successfully !!');
          setCategoryList(data as CategoryItemType);
          setTotalRecords(data?.total);
        })
        .catch((error: any) => {
          toast.error(error.message);
        });
    } catch (error) {
      console.error('Error toggling category status:', error);
    }
  };

  // const handleSelectAll = (): void => {
  //   if (allChecked) {
  //     setAllChecked(false);
  //   } else {
  //     setAllChecked(true);
  //   }
  // };
  useEffect(() => {
    if (allChecked) {
      const allIds: any = categoryList?.data?.data?.map(
        (item: {id: any}) => item.id,
      ); // Select all by their IDs
      setSelectedProductIds(allIds);
    } else {
      if (!Checked) {
        setSelectedProductIds([]);
      }
    }
  }, [allChecked, categoryList]);

  // const handleCheckboxChange = (productId: number): void => {
  //   let updatedSelectedProductIds: number[] = [];

  //   if (selectedProductIds.includes(productId)) {
  //     // Uncheck child, remove it from the array
  //     updatedSelectedProductIds = selectedProductIds.filter(
  //       id => id !== productId,
  //     );
  //   } else {
  //     // Check child, add it to the array
  //     updatedSelectedProductIds = [...selectedProductIds, productId];
  //   }

  //   setSelectedProductIds(updatedSelectedProductIds);
  // };

  // useEffect(() => {
  //   dispatch(setProductIds(selectedProductIds));
  //   if (selectedProductIds.length > 0) {
  //     setIsCheckboxChanged(true);
  //   } else {
  //     setIsCheckboxChanged(false);
  //   }
  // }, [selectedProductIds]);
  useEffect(() => {
    dispatch(setProductIds(selectedProductIds));
    if (selectedProductIds.length > 0) {
      setIsCheckboxChanged(true);
    } else {
      setIsCheckboxChanged(false);
    }
    const categorylength: any = categoryList?.data?.data?.length;

    if (selectedProductIds.length === categorylength) {
      setAllChecked(true);
      seChecked(false);
    }
    if (selectedProductIds.length < categorylength) {
      setAllChecked(false);
      seChecked(true);
    }
  }, [selectedProductIds]);

  const productIds = useSelector(
    (state: any) => state.statusChange.setProductids,
  );
  const setproductstatus = async (e: any): Promise<void> => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Want to change status for selected After Parties',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    });
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (result.isConfirmed) {
      dispatch(changeStatus(e.target.value, productIds, 'category'));
      setisStatusChange(true);
    }
  };
  useEffect(() => {
    setAllChecked(false);
    setSelectedProductIds([]);
  }, [isStatusChange]);
  const columns = [
    // {
    //   id: 'parentBox', // Give the column a unique ID
    //   Header: () => (
    //     <input
    //       className="parentCheckbox"
    //       type="checkbox"
    //       checked={allChecked} // This binds the checked state to `allChecked`
    //       value="0"
    //       onChange={() => {
    //         // handleSelectAll();
    //       }}
    //     />
    //   ),
    //   disableFilters: true,
    //   filterable: true,
    //   accessor: '',
    //   Cell: (cell: any) => {
    //     return (
    //       <div className="d-inline-flex align-items-center gap-3">
    //         <input
    //           className={
    //             selectedProductIds.includes(cell.row.original.id)
    //               ? 'checked-class'
    //               : 'unchecked-class'
    //           }
    //           value={cell.row.original.id}
    //           type="checkbox"
    //           checked={selectedProductIds.includes(cell.row.original.id)}
    //           onChange={() => {
    //             handleCheckboxChange(cell.row.original.id);
    //           }}
    //         />
    //       </div>
    //     );
    //   },
    // },
    {
      Header: 'Name',
      disableFilters: true,
      filterable: true,
      accessor: 'name',
      Cell: (cellProps: any) => {
        return cellProps.value;
      },
    },
    {
      Header: 'Date',
      disableFilters: true,
      filterable: true,
      accessor: 'datetime',
      Cell: (cellProps: any) => {
        return moment(cellProps.value).format('Do MMM, YYYY hh:mm A');
      },
    },
    {
      Header: `Max capacity`,
      disableFilters: true,
      filterable: true,
      accessor: 'after_party_max_capacity',
      Cell: (cellProps: any) => {
        return cellProps.value;
      },
    },
    {
      Header: `Number of join users`,
      disableFilters: true,
      filterable: true,
      accessor: 'total_after_party_user_count',
      Cell: (cellProps: any) => {
        return cellProps.value;
      },
    },
    {
      Header: `Location`,
      disableFilters: true,
      filterable: true,
      accessor: 'location',
      Cell: (cellProps: any) => {
        return (
          <>
            <a href={cellProps.value} target="_blank" rel="noreferrer">
              {cellProps.value}
            </a>
          </>
        );
      },
    },
    {
      Header: `Party Type`,
      disableFilters: true,
      filterable: true,
      accessor: 'party_type',
      Cell: (cellProps: any) => {
        return cellProps.value === 1
          ? 'Puravida Party'
          : cellProps?.value === 2
            ? 'Club Party'
            : '-';
      },
    },
    // {
    //   Header: 'Status',
    //   disableFilters: true,
    //   filterable: true,
    //   accessor: 'status_id',
    //   Cell: ({cell}: {cell: {value: number}}) => {
    //     const status = statusList.find(
    //       (status: any): any => cell.value === status?.id,
    //     );

    //     return (
    //       <span
    //         className={`badge text-uppercase ${
    //           status?.id === variables.CATEGORY_ACTIVE_STATUS_ID
    //             ? 'bg-success-subtle text-success'
    //             : 'bg-danger-subtle text-danger'
    //         }`}>
    //         {status?.id === variables.CATEGORY_ACTIVE_STATUS_ID
    //           ? variables.CATEGORY_ACTIVE_STATUS
    //           : variables.CATEGORY_INACTIVE_STATUS}
    //       </span>
    //     );
    //   },
    // },

    {
      Header: 'Status',
      disableFilters: true,
      filterable: true,
      accessor: 'status',
      Cell: (cellProps: any) => {
        const isActive =
          cellProps.value === variables.AFTER_PARTY_ACTIVE_STATUS_ID;
        const newStatusId =
          cellProps.value === variables.AFTER_PARTY_ACTIVE_STATUS_ID
            ? variables.AFTER_PARTY_INACTIVE_STATUS_ID
            : variables.AFTER_PARTY_ACTIVE_STATUS_ID;
        const toggleStatus = async (): Promise<void> => {
          await toggleCategoryStatus(
            cellProps?.cell?.row?.original?.id,
            newStatusId,
          );
        };

        return (
          <div className="form-check form-switch d-flex gap-1">
            <Form.Check
              type="checkbox"
              role="switch"
              id="flexSwitchCheckChecked"
              onChange={toggleStatus}
              checked={isActive}
              className="form-switch-md"
            />
            <div>
              <Form.Label htmlFor="flexSwitchCheckChecked">
                {isActive
                  ? variables.CATEGORY_ACTIVE_STATUS
                  : variables.CATEGORY_INACTIVE_STATUS}
              </Form.Label>
            </div>
          </div>
        );
      },
    },

    {
      Header: 'Action',
      disableFilters: true,
      filterable: true,
      accessor: (cellProps: any) => {
        return (
          <Dropdown className="text-start">
            <Dropdown.Toggle className="btn btn-ghost-primary btn-icon btn-sm arrow-none">
              <i className="mdi mdi-dots-horizontal" />
            </Dropdown.Toggle>
            <Dropdown.Menu as="ul" className="dropdown-menu-end">
              <li>
                <Dropdown.Item
                  onClick={() => {
                    setEditCategory(cellProps);
                    modalToggle();
                  }}>
                  <i className="ri-pencil-fill align-bottom me-2 text-muted" />{' '}
                  Edit
                </Dropdown.Item>
              </li>
              <li>
                <Dropdown.Item
                  onClick={async () => {
                    await handleDeleteCategory(cellProps?.id);
                  }}
                  className="remove-list">
                  <i className="ri-delete-bin-fill align-bottom me-2 text-muted" />
                  Delete
                </Dropdown.Item>
              </li>
            </Dropdown.Menu>
          </Dropdown>
        );
      },
    },
  ];

  function modalToggle(): void {
    setModalFlag(!modalFlag);
  }

  return (
    <div className="page-content">
      <Container fluid={true}>
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0">Puravida Party</h4>
        </div>
        <div id="couponsList">
          <Row>
            <Col lg={12}>
              <Card>
                <Card.Body className="bg-soft-light border border-dashed border-start-0 border-end-0">
                  <Form>
                    <Row className="g-3 justify-content-between align-items-center">
                      <Col lg={4}>
                        <div
                          aria-labelledby="category-name-label"
                          className="mb-3">
                          <Form.Label
                            id="category-name-label"
                            htmlFor="category-name">
                            Party Type
                          </Form.Label>
                          <Select
                            className="custom-select"
                            id="venue-name"
                            name="venue-name"
                            value={filter}
                            onChange={handleSelectVenueChange}
                            styles={isDark ? customStyles : {}}
                            options={SelectionOptions}></Select>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Card>
                <Card.Body>
                  <TableContainer
                    columns={columns ?? []}
                    data={categoryList?.data ?? []}
                    iscustomPageSize={false}
                    handleNextPagination={handleNextPagination}
                    handlePrevPagination={handlePrevPagination}
                    pageValue={pageValue}
                    isBordered={true}
                    customPageSize={pageSize}
                    isGlobalFilter={true}
                    pageSize={pageSize}
                    currentData={currentData}
                    setPageSize={setPageSize}
                    isAddOptions={true}
                    className="custom-header-css"
                    tableClass="table-centered align-middle table-nowrap mb-0"
                    theadClass="text-muted table-light"
                    SearchPlaceholder="Search After Parties..."
                    buttonText="Add Puravida Party"
                    onClick={() => {
                      setEditCategory({});
                      modalToggle();
                    }}
                    // sortColumn={sortColumn}
                    // sortDirection={sortDirection}
                    // handleSortByColumn={handleSortByColumn}
                    onSearch={handleSearch}
                    isChangeStatus={isCheckboxChanged}
                    isCategory={true}
                    statusClickevent={setproductstatus}
                    resetSearchFlag={resetSearchFlag}
                  />
                  <div className="noresult" style={{display: 'none'}}>
                    <div className="text-center">
                      <h5 className="mt-2">Sorry! No Result Found</h5>
                      <p className="text-muted mb-0">
                        We've searched more than 150+ Orders We did not find any
                        orders for you search.
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

        <ModalContainer
          showModal={modalFlag}
          handleClose={modalToggle}
          modalTitle={
            editCategory.id !== undefined
              ? 'Edit Puravida Party'
              : 'Add Puravida Party'
          }
          modalBody={
            <>
              <AfterPartyForm
                handleClose={modalToggle}
                editCategory={editCategory}
                setIsEditCategory={setIsEditCategory}
                setIsAddCategory={setIsAddCategory}
                clubList={clubList}
              />
            </>
          }
        />
      </Container>
    </div>
  );
};

export default AfterParties;
